'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const ppc = require('static-site-generator-shared/plugins/lib/ppc');
const Helpers = require('static-site-generator-shared/plugins/lib/helpers');
const EngineHelper = {
  getHiddenInput(name, options, expiry, domain, props) {
    if (!name) return false;
    // Fix this
    let value = options && ppc.searchQueryStringAndSet(options);
    if (!value) value = Helpers.getCookie(name);
    if (value && !props.ignoreCookies) Helpers.setCookie(name, value, expiry, domain);
    return value;
  },
  getHiddenInputs(props, cookieExpiryDays = 30) {
    const agentData = props && props.agentData ? props.agentData : null;
    let expiry = new Date();
    expiry.setTime(expiry.getTime() + cookieExpiryDays * 24 * 60 * 60 * 1000);
    const hiddenInputs = {};
    const cookieDomain = typeof window !== 'undefined' ? window.location.host : null;
    const wowcherCode = props && props.wowcherCode ? props.wowcherCode : '';
    if (agentData && agentData.agent && agentData.agent !== wowcherCode) {
      hiddenInputs.LaunchID = this.getHiddenInput('LaunchID', ['launch_id', 'LaunchID'], expiry, cookieDomain, props);
    }
    if (props.promotionCode) hiddenInputs.promotionCode = props.promotionCode;
    hiddenInputs.custref = this.getHiddenInput('custref', ['cust_ref', 'custref', 'customer_ref'], expiry, cookieDomain, props);
    hiddenInputs.rule_set = this.getHiddenInput('rule_set', ['rule_set', 'ruleset', 'ruleSet'], expiry, cookieDomain, props);
    hiddenInputs.midocoid = this.getHiddenInput('midocoid', ['midocoid', 'midocoId', 'midoco_id'], expiry, cookieDomain, props);
    hiddenInputs.midocobasket = this.getHiddenInput('midocobasket', ['midocobasket', 'midoco_basket', 'midocoBasket'], expiry, cookieDomain, props);
    hiddenInputs.email = this.getHiddenInput('email', ['Email', 'email', 'email_address'], expiry, cookieDomain, props);
    hiddenInputs.Email = this.getHiddenInput('Email', ['Email', 'email', 'email_address'], expiry, cookieDomain, props);
    hiddenInputs.CampaignID = this.getHiddenInput('CampaignID', ['CampaignID', 'Campaign_ID'], expiry, cookieDomain, props);
    if (this.setState) {
      this.setState({
        hiddenInputs
      });
    }
    return hiddenInputs;
  },
  getLocation(props, defaultLocation) {
    const {
      ignoreCookies,
      hiddenLocation,
      Location
    } = props;
    if (ignoreCookies) {
      return hiddenLocation || Location || defaultLocation;
    }
    return hiddenLocation || this.engineCookies('Location', null, props) || defaultLocation;
  },
  getFirstRoom(props, defaultRoomType) {
    const {
      ignoreCookies,
      roomTypeSelected
    } = props;
    if (ignoreCookies) {
      return roomTypeSelected || defaultRoomType;
    }
    return this.engineCookies('RoomType[0]', null, props) || defaultRoomType;
  },
  getSecondRoom(props, defaultRoomType) {
    const {
      ignoreCookies,
      secondRoom
    } = props;
    if (ignoreCookies) {
      return secondRoom || defaultRoomType;
    }
    return this.engineCookies('RoomType[1]', null, props) || defaultRoomType;
  },
  getActiveTime(props, defaultTime) {
    const {
      ignoreCookies,
      fromTime
    } = props;
    if (ignoreCookies) {
      return fromTime || defaultTime;
    }
    return this.engineCookies('activeTime', null, props) || defaultTime;
  },
  shouldShowSecondRoom(props) {
    const {
      showSecondRoom
    } = props;
    if (showSecondRoom !== null) return showSecondRoom;
    return EngineHelper.engineCookies('showSecondRoom', null, props);
  },
  checkUpdated(next, current) {
    if (typeof next === 'object') {
      return JSON.stringify(next) !== JSON.stringify(current);
    }
    return next !== current;
  },
  getInitialLocation(hiddenLocation, Location, validLocations, defaultLocation) {
    /*
    * Return the airport location when the engine mounts. If the cookieLocation
    * is not valid for this engine, use a default location.
    */
    const cookieLocation = this.engineCookies('Location');
    const isValidLocation = this.checkCookieLocationIsValid(cookieLocation, validLocations);
    const validCookieLocation = isValidLocation ? cookieLocation : false;
    return hiddenLocation || validCookieLocation || Location || defaultLocation;
  },
  checkCookieLocationIsValid(cookieLocation, validLocations = {}) {
    /*
    * Check the current cookie location against an array of valid locations for the specified engine.
    * If the cookieLocation is not present return false.
    */
    const locationRegex = /[A-Z]{3}/;
    const validLocationsArr = Object.keys(validLocations);
    /*
    * Lounges has an extra level of keys, so if the first level of keys don't
    * match the "XYZ" location format, we know to check the next level down.
    */
    if (!locationRegex.test(validLocationsArr)) {
      for (let i = 0; i < validLocationsArr.length; i++) {
        if (Object.keys(validLocations[validLocationsArr[i]]).indexOf(cookieLocation) > -1) return true;
      }
      return false;
    }
    return validLocationsArr.indexOf(cookieLocation) > -1;
  },
  engineCookies(name, value, props = {}) {
    if (props.ignoreCookies) return;
    if (props.engineType) name = props.engineType + name; // Incase you want to keep engines separate
    name = 'Engines_' + name;
    if (typeof value === 'undefined') return Helpers.getCookie(name);
    if (!value) return Helpers.setCookie(name, value, (d => new Date(d.setDate(d.getDate() - 1)))(new Date()));
    Helpers.setCookie(name, value);
  },
  // Params: Object
  // {
  //  form: Helpers.$('#parkingEngine'),
  //  type: 'CarParking',
  //  cookieKey: 'Engines_'
  // }

  setupCalendars(params) {
    const i = setInterval(() => {
      if (!window.SetupCalendars || !window.$.fn.pickadate) return;
      clearInterval(i);
      return new window.SetupCalendars(params);
    }, 50);
  },
  changeUrl(url) {
    if (!url) return;
    window.location.assign(url);
  },
  inArray(needle, haystack) {
    const length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i] === needle) return true;
    }
    return false;
  },
  adjustTrackingDates(date, time) {
    const newDate = new Date(date);
    newDate.setHours(12);
    return newDate.toISOString().replace(/T[0-9]{2}:[0-9]{2}/, `T${time.slice(0, 2)}:${time.slice(-2)}`);
  },
  uuid() {
    let d = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    }).replace(/-/g, ''); // Remove hyphens at the moment (May change)
  }
};
var _default = exports.default = EngineHelper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/engineHelper.js
// module id = 35
// module chunks = 119